import Cookies from 'universal-cookie';
import isBrowser from 'util/isBrowser';

export const BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || 'localhost:3000';
export const BASE_WEBSOCKET_URL =
  process.env.NEXT_PUBLIC_WEBSOCKET_API_BASE_URL || 'ws://localhost:3000/cable';

export function headers() {
  if (isBrowser()) {
    const access_token = localStorage.getItem('access_token');
    const refresh_token = localStorage.getItem('refresh_token');
    const cookies = new Cookies();
    const current_employer_profile_id = localStorage.getItem('current_employer_profile_id');
    return {
      'Content-Type': 'application/vnd.api+json',
      Authorization: `Bearer ${access_token}`,
      'Refresh-Token': refresh_token,
      'Current-Employer-Profile-Id': current_employer_profile_id,
    };
  }
  return {
    'Content-Type': 'application/vnd.api+json',
  };
}

export default async function apiCall(path, method, options) {
  const url = `${BASE_URL}/${path}`;
  return fetch(url, {
    ...options,
    method: method,
    headers: headers(),
  }).then((response) => {
    return (response || '{}').json();
  });
}
